import React from "react";
import { styled } from "@iventis/styles";
import CustomFormikField from "./custom-formik-textfield";

const WrapperCustomFormikField: React.FunctionComponent<{
    name: string;
    label?: string;
    placeholder?: string;
    width?: string | number;
    marginTop?: string | number;
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    className?: string;
    disabled?: boolean;
    multiline?: boolean;
    rows?: number;
}> = ({ name, label, value, onChange, width, marginTop, className, placeholder, disabled, multiline, rows }) => (
    <StyledWrapper width={width} className={className}>
        <CustomFormikField
            placeholder={placeholder}
            name={name}
            label={label}
            value={value}
            onChange={onChange}
            marginTop={marginTop}
            disabled={disabled}
            multiline={multiline}
            rows={rows}
        />
    </StyledWrapper>
);
const StyledWrapper = styled.div<{ width?: string | number }>`
    display: flex;
    width: ${(props) => props.width || "100%"};
`;
export default WrapperCustomFormikField;
